// Tipos del módulo Activos + Rentas (ERP núcleo de renta).
// Backend: /api/v1/admin/assets/* (mcp_django).

export type AssetStatus =
  | 'available' | 'rented' | 'maintenance' | 'retired' | 'lost';

export type RateUnit = 'day' | 'week' | 'month' | 'flat' | '';

export type RentalStatus =
  | 'quote' | 'reserved' | 'active' | 'overdue' | 'returned' | 'cancelled';

export interface Asset {
  id: string;
  name: string;
  category: string;
  identifier: string;
  status: AssetStatus;
  location: string;
  attributes: Record<string, unknown>;
  default_rate_amount: number | null;
  default_rate_unit: RateUnit;
  current_holder_id: string | null;
  current_holder_name: string;
  current_rental_id: string | null;
  created_at: string;
}

export interface AssetInput {
  name: string;
  category?: string;
  identifier?: string;
  status?: AssetStatus;
  attributes?: Record<string, unknown>;
  location?: string;
  default_rate_amount?: number | null;
  default_rate_unit?: RateUnit;
  notes?: string;
}

export interface RentalLine {
  id: string;
  asset_id: string | null;
  asset_name: string;
  qty: number;
  rate_amount: number | null;
  rate_unit: RateUnit;
  active: boolean;
  added_at: string;
  removed_at: string;
  change_reason: string;
  replaces_id: string | null;
}

export interface Rental {
  id: string;
  status: RentalStatus;
  client_id: string | null;
  client_name: string;
  rate_unit: RateUnit;
  start_date: string;
  end_date: string;
  returned_at: string;
  deposit: number | null;
  total: number | null;
  balance: number | null;
  has_pagare: boolean;
  pagare_number: string;
  notes: string;
  lines: RentalLine[];
  created_at: string;
}

export interface Movement {
  id: string;
  type: string;
  asset_id: string | null;
  asset_name: string;
  rental_id: string | null;
  client_name: string;
  qty: number;
  note: string;
  swap_group: string | null;
  occurred_at: string;
}

export const ASSET_STATUS_LABEL: Record<AssetStatus, string> = {
  available: 'Disponible',
  rented: 'Rentado',
  maintenance: 'Mantenimiento',
  retired: 'Baja',
  lost: 'Extraviado',
};

export const RENTAL_STATUS_LABEL: Record<RentalStatus, string> = {
  quote: 'Cotización',
  reserved: 'Reservada',
  active: 'Activa',
  overdue: 'Vencida',
  returned: 'Cerrada',
  cancelled: 'Cancelada',
};

export const RATE_UNIT_LABEL: Record<string, string> = {
  day: 'día', week: 'semana', month: 'mes', flat: 'fijo', '': '',
};

// ── BI de flota (F7) ────────────────────────────────────────
export interface UnitBI {
  asset_id: string;
  name: string;
  identifier: string;
  category: string;
  status: string;
  rented_days: number;
  period_days: number;
  utilization_pct: number;
  revenue: number;
  service_cost: number;
  net: number;
  roi_pct: number;
  hour_meter: number;
  hours_until_service: number;
}

export interface FleetBI {
  period: { start: string; end: string; days: number };
  fleet: {
    units: number;
    avg_utilization_pct: number;
    revenue: number;
    service_cost: number;
    net: number;
    idle_units: string[];
  };
  availability_by_category: Record<string, { total: number; available: number; out_of_service: number }>;
  quotes: { won: number; lost: number; conversion_pct: number; lost_reasons: string[] };
  collections: { overdue_balance: number };
}

// ── Disponibilidad / calendario (F6) ────────────────────────
export interface Availability {
  start_date: string;
  end_date: string;
  total_units: number;
  out_of_service: number;
  occupied: number;
  available: number;
  available_units: Array<{ id: string; name: string; identifier: string; category: string; status: string }>;
}
